// src/firebase.js
import firebase from "firebase/compat/app";
import "firebase/compat/messaging";

// Your Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyDbSSyyPW8MEb2R8jT5dSb5ntliwi3SbZU",
  authDomain: "mybuilderid-e7f6c.firebaseapp.com",
  databaseURL: "https://mybuilderid-e7f6c.firebaseio.com",
  projectId: "mybuilderid-e7f6c",
  storageBucket: "mybuilderid-e7f6c.appspot.com",
  messagingSenderId: "552465314432",
  appId: "1:552465314432:web:17db212118245b7f8cac65",
  measurementId: "G-BKN3R2MQ4V"
};

//  Only initialize if no apps exist
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
  // console.log("Firebase initialized");
}

const messaging = firebase.messaging();

// Get Token Function
export const getToken = async () => {
  try {
    // Request notification permission
    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      console.log("Notification permission not granted");
      return null;
    }

    // Check if SW is registered with scope "/", if not, register it immediately
    let registration = await navigator.serviceWorker.getRegistration("/");
    if (!registration) {
      // console.log("Registering Service Worker from firebase.js...");
      registration = await navigator.serviceWorker.register("/firebase-messaging-sw.js", { scope: "/" });
    }

    // Wait for it to be ready
    await navigator.serviceWorker.ready;

    const currentToken = await messaging.getToken({
      vapidKey:
        "BLqS6UxNajiFwuBlN9CHBxRxUSBlXZQuiqwgmzeJ7_LvxaW5eH-xHBJq1ULAumTGi_bX1D3aeL4LYIXI3S6sQsk",
      serviceWorkerRegistration: registration
    });

    if (currentToken) {
      // console.log("FCM Token:", currentToken);
    } else {
      console.log("No registration token available. Request permission to generate one.");
    }
    return currentToken;
  } catch (error) {
    console.error("getToken-> An error occurred while retrieving token:", error);
    return null;
  }
};

export const onMessageListener = () => {
  return new Promise(async (resolve) => {
    try {
      if (Notification.permission !== "granted") {
        await Notification.requestPermission();
      }

      await getToken();

      resolve(messaging);
    } catch (error) {
      resolve(messaging);
      console.error("Error in onMessageListener:", error);
    }
  });
};

export default firebase;
